import * as React from "react";
import {InputBase} from "@mui/material";
import clsx from "clsx";


interface LeadSearchProps {
    placeholder: string,
    value: string,
    setValue: React.Dispatch<React.SetStateAction<string>>,
    className: string
}

export const SearchInput: React.FC<LeadSearchProps> = (props) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.setValue(event.target.value);
    };

    return (
        <InputBase
            id="lead-search-input"
            className={clsx(props.className, 'inputBase')}
            type="text"
            value={props.value}
            onChange={handleChange}
            placeholder={props.placeholder}

        />
    );
};
